import { render, staticRenderFns } from "./ListResponseRoboCnpjView.vue?vue&type=template&id=05b2e3b4&"
import script from "./ListResponseRoboCnpjView.vue?vue&type=script&lang=ts&"
export * from "./ListResponseRoboCnpjView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports